module.exports = __webpack_public_path__ + "static/media/needle_darkmode.324de633.png";